<template>
    <v-app-bar
      app
      color="rgba(255, 255, 255, 0.8)"
      height="50"
    >
      <v-toolbar-title class="font-weight-black headline">
        {{$t("briefcase")}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="changeLocale('es')">
        <img
          :class="{ active_lg: $i18n.locale == 'es' }"
          height="20px"
          width="30px"
          src="../assets/img/flags/es.png"
        >
      </v-btn>

      <v-btn icon @click="changeLocale('en')">
        <img
          :class="{ active_lg: $i18n.locale == 'en' }"
          height="20px"
          width="30px"
          src="../assets/img/flags/en.png"
        >
      </v-btn>
    </v-app-bar>
</template>
<script>
import i18n from '@/plugins/i18n';
export default {
    name: 'App',

  components:{

  },
  data: () => ({}),
  methods:{
    changeLocale :(locale) => {
      i18n.locale = locale;
    }
  }
}
</script>
<style lang="scss" scoped>
  .active_lg{
    border:1px solid black;
  }
</style>